// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"vendors-hls_js_dist_hls_mjs":"a32b39ee8b61fd17f2db","vendors-howler_dist_howler_js":"2b6e1dd472f4127c3279"}[chunkId] + ".js";
};